/* global gapi:true */
import { createOnDOMReady } from 'shared/utils/dom';
import { captureException } from 'shared/utils/handlerErrors';

const onDOMReady = createOnDOMReady(document);

export const loadAuth2 = () =>
  new Promise((resolve, reject) => {
    gapi.load('auth2', {
      callback: () => {
        resolve();
      },
      error: (error) => {
        captureException(error);
        reject(error);
      },
    });
  });

export const callInitAuth2 = () =>
  new Promise((resolve, reject) => {
    gapi.auth2
      .init({
        client_id: process.env.GOOGLE_AUTH2_CLIENT_ID,
        cookiepolicy: process.env.GOOGLE_AUTH2_COOKIEPOLICY,
      })
      .then(resolve)
      .catch((error) => {
        if (error?.error !== 'idpiframe_initialization_failed') {
          captureException(error);
        }
        reject(error);
      });
  });

export const initAuth2 = () =>
  new Promise((resolve, reject) => {
    onDOMReady(() => {
      callInitAuth2().then(resolve).catch(reject);
    });
  });

export const getUserData = (user) => ({
  token: user.getAuthResponse().id_token,
  email: user.getBasicProfile().getEmail(),
});

export const signIn = () =>
  new Promise((resolve, reject) => {
    const user = gapi.auth2.getAuthInstance().currentUser.get();

    if (user.isSignedIn()) {
      resolve(getUserData(user));
    } else {
      gapi.auth2
        .getAuthInstance()
        .signIn()
        .then((newUser) => resolve(getUserData(newUser)))
        .catch((error) => {
          captureException(error);
          reject(error);
        });
    }
  });
